import { useEffect } from 'react'
import useInstance from './useInstance'

export default (event, eventProps = {}) => {
  const amplitudeInstance = useInstance()
  useEffect(() => {
    amplitudeInstance.logEvent(event, eventProps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
